import { jsxs as a, jsx as s } from "react/jsx-runtime";
import l from "clsx";
import '../_assets/PlusToMinusIcon.BqgvXuwt.css';const p = "_icon_1268f_1", d = "_active_1268f_7", e = {
  icon: p,
  active: d
}, f = ({
  size: o = 16,
  color: n = "currentColor",
  strokeWidth: t = 1.5,
  className: i,
  isOpen: c = !1,
  ...r
}) => /* @__PURE__ */ a(
  "svg",
  {
    className: l(e.icon, i, c && e.active),
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 25 25",
    fill: "none",
    ...r,
    children: [
      /* @__PURE__ */ s(
        "path",
        {
          d: "M4.75 12H20.75",
          stroke: n,
          strokeWidth: t,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ s(
        "path",
        {
          d: "M12.75 4L12.75 20",
          stroke: n,
          strokeWidth: t,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  f as PlusToMinusIcon
};
